import { type MetaFunction } from '@remix-run/node'
// import {
// 	Tooltip,
// 	TooltipContent,
// 	TooltipProvider,
// 	TooltipTrigger,
// } from '#app/components/ui/tooltip.tsx'
import { Link } from '@remix-run/react'
import {Button} from "#app/components/ui/button.tsx"
import background from "./logos/Background Picture Loving Words.png"

export const meta: MetaFunction = () => [{ title: 'Loving Words' }]

export default function Index() {
	return (
		// <main className="relative min-h-screen sm:flex sm:items-center sm:justify-center">
		<main className="relative">
			{/* <div className="relative sm:pb-16 sm:pt-3"> */}
			<div className="relative">
				<div className="mx-auto">
					<div className="relative shadow-xl sm:overflow-hidden">
						<div className="absolute inset-0">
							<img className="h-full w-full object-cover" src={background} alt="" />
							{/* <div className="absolute inset-0 bg-[color:rgba(30,23,38,0.5)] mix-blend-multiply" /> */}
						</div>
						<div className="relative flex items-center justify-center">
							<div className="bg-white w-3/4 mx-16 my-16 max-w-3xl p-12">
								<h6 className='font-workSans text-center text-secondary font-thin tracking-tight text-4xl md:text-6xl mt-6'>
									What is Loving Words?
								</h6>
								<p className="font-proximaNova text-secondary text-justify mt-6 text-md md:text-lg tracking-tight">
								Welcome to Loving Words! Our mission is to immerse you in the world of poetry by being your personal poetry tutor powered by AI. 
								Loving Words draws inspiration from its extensive collection of previously published poems, generously shared by their creators.
								</p>
								<p className="font-proximaNova text-secondary text-justify mt-6 text-md md:text-lg tracking-tight">
								It has been studied that poetry is an artform that allows people to express themselves in ways traditional communication cannot. 
								There is evidence showing the therapeutic benefits of poetry across various vulnerable groups such as those dealing with 
								Post Traumatic Stress Disorder, prisoners, seniors, including those with dementia, and adolescents. Poetry acts as a 
								non-medical intervention to promote public health and wellbeing, with significant potential in enhancing quality of life. 
								</p>
								<p className="font-proximaNova text-secondary text-justify mt-6 text-md md:text-lg tracking-tight">
								Reading and writing poetry can have significant benefits, yet many find the process of crafting poems daunting. 
								Loving Words provides a platform to discover and enjoy poetry and it also offers guidance on crafting your own verse. 
								Loving Words is designed to make the exploration and creation of poetry seamless and free.
								</p>
								<div className="flex items-center justify-center pt-12">
									<Button asChild variant="secondary" size="lg" className='p-8' >
										<Link to="/login">
											<p className='font-workSans font-thin text-xl p-6'>
												Let's Explore Poetry!
											</p>
										</Link>
									</Button>
								</div>
							</div>
							
						</div>
						{/* <div className="lg:pt-18 relative px-4 pb-8 pt-8 sm:px-6 sm:pb-14 sm:pt-16 lg:px-8 lg:pb-20"> */}
							{/* <h2 className="text-center text-mega font-extrabold tracking-tight sm:text-8xl lg:text-9xl">
								<a
									className="block uppercase text-white drop-shadow-md"
									href="https://www.google.com"
								>
									<span>Loving Words</span>
									<svg
										className="mx-auto mt-2"
										xmlns="http://www.w3.org/2000/svg"
										width="120"
										height="120"
										fill="none"
										viewBox="0 0 65 65"
									>
										<path
											fill="currentColor"
											d="M39.445 25.555 37 17.163 65 0 47.821 28l-8.376-2.445Zm-13.89 0L28 17.163 0 0l17.179 28 8.376-2.445Zm13.89 13.89L37 47.837 65 65 47.821 37l-8.376 2.445Zm-13.89 0L28 47.837 0 65l17.179-28 8.376 2.445Z"
										></path>
									</svg>
								</a>
							</h2> */}
							{/* <h3 className='font-workSans text-center text-green-900 font-extralight tracking-tight text-3xl sm:text-4xl lg:text-6xl'>
								What is Loving Words?
							</h3>
							<p className=" text-slate-200 text-center mt-6 text-lg tracking-tight">
								Welcome to Loving Words! Our mission is to immerse you in the world of poetry by being your personal poetry tutor powered by AI. 
								Loving Words draws inspiration from its extensive collection of previously published poems, generously shared by their creators.
							</p>
							<p className="mx-20 text-slate-200 text-center max-w-lg mt-6 text-lg sm:max-w-3xl">
							It has been studied that poetry is an artform that allows people to express themselves in ways traditional communication cannot. 
							There is evidence showing the therapeutic benefits of poetry across various vulnerable groups such as those dealing with 
							Post Traumatic Stress Disorder, prisoners, seniors, including those with dementia, and adolescents. Poetry acts as a 
							non-medical intervention to promote public health and wellbeing, with significant potential in enhancing quality of life. 
							</p>
							<p className="mx-20 text-slate-200 text-center max-w-lg mt-6 text-lg sm:max-w-3xl">
							Reading and writing poetry can have significant benefits, yet many find the process of crafting poems daunting. 
							Loving Words provides a platform to discover and enjoy poetry and it also offers guidance on crafting your own verse. 
							Loving Words is designed to make the exploration and creation of poetry seamless and free.
							</p>
							<div className="flex items-center justify-center pt-12">
								<Button asChild variant="destructive" size="lg" >
									<Link to="/login">
										<p className='font-bold text-3xl px-12'>
											Let's Explore Poetry!
										</p>
									</Link>
								</Button>
							</div>
						</div> */}
					</div>
				</div>

				{/* <div className="mx-auto mt-8 max-w-7xl px-4 py-2 sm:px-6 lg:px-8"> */}
					{/* <div className="flex flex-wrap justify-center gap-8 rounded-3xl bg-slate-100 py-4 dark:bg-slate-200">
						<TooltipProvider>
							{logos.map(img => (
								<Tooltip key={img.href}>
									<TooltipTrigger asChild>
										<a
											href={img.href}
											className="flex h-16 w-32 justify-center p-1 grayscale transition hover:grayscale-0 focus:grayscale-0"
										>
											<img
												alt={img.alt}
												src={img.src}
												className="object-contain"
											/>
										</a>
									</TooltipTrigger>
									<TooltipContent>{img.alt}</TooltipContent>
								</Tooltip>
							))}
						</TooltipProvider>
					</div> */}
				{/* </div> */}
			</div>
		</main>
	)
}
